/**
 * Profile intention — conceptual life-circle direction for a person profile.
 * Stored locally until a server field is added; does not change core person model logic.
 */

export const PROFILE_INTENTION = {
  STANDARD: 'standard',
  FIRST_CHAPTER: 'first_chapter',
  MEMORIAL: 'memorial',
};

export const PROFILE_INTENTION_OPTIONS = [
  {
    value: PROFILE_INTENTION.STANDARD,
    label: 'Standard profile',
    description: 'A full life story in your family archive.',
  },
  {
    value: PROFILE_INTENTION.FIRST_CHAPTER,
    label: 'First Chapter',
    description: 'Welcome a new life — birth, adoption, or joining the family.',
  },
  {
    value: PROFILE_INTENTION.MEMORIAL,
    label: 'Memorial profile',
    description: 'Remember someone who has died — private until you publish.',
  },
];

const STORAGE_KEY = 'mlb_profile_intention_v1';

function readMap() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

function writeMap(map) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* ignore quota / private mode */
  }
}

export function getProfileIntention(person) {
  if (!person?.id) return PROFILE_INTENTION.STANDARD;
  const map = readMap();
  return map[person.id] || PROFILE_INTENTION.STANDARD;
}

export function setProfileIntention(personId, intention) {
  if (!personId) return;
  const map = readMap();
  if (!intention || intention === PROFILE_INTENTION.STANDARD) {
    delete map[personId];
  } else {
    map[personId] = intention;
  }
  writeMap(map);
}

export function getProfileIntentionLabel(intention) {
  return PROFILE_INTENTION_OPTIONS.find((o) => o.value === intention)?.label || 'Standard profile';
}

export function isFirstChapterProfile(person) {
  return getProfileIntention(person) === PROFILE_INTENTION.FIRST_CHAPTER;
}

export function isMemorialIntentionProfile(person) {
  return getProfileIntention(person) === PROFILE_INTENTION.MEMORIAL;
}
